(function ($) {
    var $ = jQuery = $;

    $(document).ready(function () {
        /**
         * Custom tab section
         */
        if($('.custom-tab__title-items').length > 0) {
            $('.custom-tab__title-item').each (function () {
                $(this).on('click', function() {
                    $('.custom-tab__title-item').removeClass('active');
                    $('.custom-tab__content-item').removeClass('active');
                    $(this).addClass('active');

                    var tabNum = $(this).data('tab-number');
                    
                    $('.custom-tab__content-item').each(function() {
                        var tabContentNum = $(this).data('tab-number');

                        if (tabNum === tabContentNum) {
                            $(this).addClass('active');
                        }
                    })
                })
            })
        }

        /**
         * Custom tab section for mobile
         */
        if($('.custom-tab__title-items').length > 0) {
            $(".custom-tab__accordion-item").click(function () {
                $(this).toggleClass("active").next(".custom-tab__content-item").slideToggle().parent().siblings().find(".custom-tab__content-item").slideUp().prev().removeClass("active");
                console.log($(this).parent().siblings());
            });
        }

        /**
         * Product variant selector
         */
        if($('.variant-selector-btn').length > 0) {
            $('body').on('click', function() {
                if($('.option-selector__btns').hasClass('open')) {
                    $('.option-selector__btns').removeClass('open');
                }
            });

            $('.variant-selector-btn').each(function() {
                $(this).on('click', function(e) {
                    e.stopPropagation();
                    if($('.option-selector__btns').hasClass('open')) {
                        $('.option-selector__btns').removeClass('open');
                    }
                    $(this).next().toggleClass('open');
                })
            });

            $('.option-selector__btns .opt-btn').each(function() {
                $(this).on('click', function(e) {
                    var img_html = '';
                    var optionValue = $(this).val();

                    switch (optionValue) {
                        case 'Black Cherry':
                            img_html = '<span style="margin-right: 15px"><img src="https://cdn.shopify.com/s/files/1/0833/8201/0132/files/cherry.png?v=1698869810" width="20"></span>';
                            break;
                        case 'Blue Raspberry':
                            img_html = '<span style="margin-right: 15px"><img src="https://cdn.shopify.com/s/files/1/0833/8201/0132/files/blueraspberry.png?v=1698869809" width="20"></span>';
                            break;
                        case 'Italian Lemon Ice':
                            img_html = '<span style="margin-right: 15px"><img src="https://cdn.shopify.com/s/files/1/0833/8201/0132/files/lemon.png?v=1698869810" width="20"></span>';
                            break;
                        case 'Strawberry':
                            img_html = '<span style="margin-right: 15px"><img src="https://cdn.shopify.com/s/files/1/0833/8201/0132/files/strawberry.png?v=1698869810" width="20"></span>';
                            break;
                    }

                    $(this).parent().parent().find('.variant-selector-btn').html(img_html + '<span>'+ optionValue +'</span>');
                });
            })
        }

        /**
         * Nutrition info popup
         */
        $('.show-information__button').on('click', function(e) {
            e.preventDefault();
            $('.information-popup').show(500);
            $('.information-overlay').show();
        });

        $('.information-overlay').on('click', function(e) {
            $('.information-popup').hide(500);
            $('.information-overlay').hide();
        });
    })
})(jQuery)